<template lang="pug">
    d2-container()
      el-form(:inline='true', :model='dataForm' size="mini" label-position='left' label-width="75px" label-suffix=':' )
        el-row(:span='24' type="flex" :gutter="40")
          el-col(:md='8' :sm="12")
            el-radio-group(v-model="timeRange" @change="timeChange" fill="#409EFF" style="display: flex; flex-warp: nowarp;")
              el-radio-button(:label="0") 今天
              el-radio-button(:label="1") 本周
              el-radio-button(:label="2") 上周
              el-radio-button(:label="3") 本月
              el-radio-button(:label="4") 上月
          el-col(:md='8' :sm="12" )
            el-date-picker(v-model="dateTime" @change="dayChange" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期")
          //- el-col(:md='8' :sm="12" )
          //-   el-radio-group(v-model="dataForm.dateType" @change="dateChange" fill="#409EFF" style='display:flex;flex-warp:nowarp')
          //-     el-radio-button(:label="1") 按月
          //-     el-radio-button(:label="2") 按季
          //-     el-radio-button(:label="3") 按年
        el-row( style='margin:20px 0 0 0' :gutter="40")
          el-col(:span='8')
            el-form-item(label='业务类型' size="medium")
              el-select.inputWidth(v-model='dataForm.busType',placeholder='请选择业务类型',clearable,@change='changeBusType')
                el-option(v-for="e in busTypeArr" :label='e.label', :value="e.value")
          el-col(:span='8')
            el-form-item(label='业务类别' size="medium")
              el-select.inputWidth(v-model='dataForm.busCategory',placeholder='请选择业务类别',clearable)
                el-option(v-for="e in busCategoryArr" :label='e.label', :value="e.value")
          el-col(:span='8')
            el-form-item(label='业务状态' size="medium")
              el-select.inputWidth(v-model='dataForm.busStatus',placeholder='请选择业务状态',clearable)
                el-option(v-for="e in busStatusArr" :label='e.label', :value="e.value")
        el-row(style="padding-bottom:15px;")
          el-col(:span="24")
            el-button(type='primary' v-show="isAuth('fs:statical:frans')" @click="exportExcel()" style="margin-left:0") 导出报表
            el-button(type='primary' icon="el-icon-search" @click="getDataList" style="float:right") 查询
            el-button(type='info' icon="el-icon-arrow-left" @click="goBack" style="float:right") 返回
        //- el-row(:span='24' type='flex' justify="start")
          //- h3(style="margin:20px 100px 0 0;color:red") 提示：微信商户平台收取0.6%的手续费00
        //- el-row(:span='24' type='flex' justify="start")
        //-   h3(style="margin:20px 100px 0 0;color:red") 总收入 ¥ {{totalAmount}}元
        //-   h3(style="margin:20px 100px 0 0;color:red") 竞赛总收入 ¥ {{totalAmountCt}}元
        //-   h3(style="margin:20px 100px 0 0;color:red") 培训总收入 ¥ {{totalAmountTr}}元
        //-   h3(style="margin:20px 100px 0 0;color:red") 总加盟费 ¥ {{totalFranchise}}元
          //- h3(style="margin:20px 100px 0 0;color:red") 竞赛总加盟费 ¥ {{totalFranchiseCt}}元
          //- h3(style="margin:20px 100px 0 0;color:red") 培训总加盟费 ¥ {{totalFranchiseTr}}元
          //- h3(style="margin:20px 100px 0 0;color:red") 总手续费 ¥ {{serviceFee}}元
      el-table(:data='infoDataList', border, v-loading='dataListLoading', style='width: 80%;margin-bottom:40px;')
          el-table-column(prop='totalAmount', header-align='center', align='center', label='不含退款收入(元)')
          el-table-column(prop='totalRefundBalanced', header-align='center', align='center', label='总退款余额(元)')
          el-table-column(prop='totalAmountCt', header-align='center', align='center', label='竞赛总收入(元)')
          el-table-column(prop='totalAmountTr', header-align='center', align='center', label='培训总收入(元)')
          el-table-column(prop='totalFranchise', header-align='center', align='center', label='总加盟费(元)')
          el-table-column(prop='totalFranchiseCt', header-align='center', align='center', label='竞赛总加盟费(元)')
          el-table-column(prop='totalFranchiseTr', header-align='center', align='center', label='培训总加盟费(元)')
          el-table-column(prop='serviceFee', header-align='center', align='center', label='总手续费(元)')
      el-table(:data='dataList', border, v-loading='dataListLoading', style='width: 100%;')
          el-table-column(type="index", header-align='center', align='center', label='序号')
          el-table-column(prop='orgName', header-align='center', align='center', label='加盟商名称')
          el-table-column(prop='busType', header-align='center', align='center', label='业务类型')
              template(slot-scope="scope")
                      span(v-if='scope.row.busType==1') 竞赛
                      span(v-if='scope.row.busType==2') 培训
          el-table-column(prop='busCategory', header-align='center', align='center', label='业务类别')
              template(slot-scope="scope")
                      span(v-if='scope.row.busCategory== -1') 青少年赛
                      span(v-if='scope.row.busCategory==1') 分级公开赛
                      span(v-if='scope.row.busCategory==2') 俱乐部公开赛
                      span(v-if='scope.row.busCategory==3') 分级单次培训
                      span(v-if='scope.row.busCategory==4') 分级整期培训
                      span(v-if='scope.row.busCategory==5') 青少年儿童培训
                      span(v-if='scope.row.busCategory==6') 个人定制化培训
                      span(v-if='scope.row.busCategory==13') 分级升级培训
          el-table-column(prop='busName', header-align='center', align='center', label='业务名称')
          el-table-column(prop='placeName', header-align='center', align='center', label='比赛场地')
          el-table-column(prop="aaaaa", header-align="center", align="center", label="签位数")
            template(slot-scope="scope")
              span() {{ scope.row.applySize ? `${scope.row.joinCount}/${scope.row.applySize}` : '-' }}
          el-table-column(prop='busCode', header-align='center', align='center', label='业务ID')
          el-table-column(prop='busStatus', header-align='center', align='center', label='业务状态')
              template(slot-scope="scope")
                span(v-if='scope.row.busStatus==1') 未审核
                span(v-if='scope.row.busStatus==2') 已发布
                span(v-if='scope.row.busStatus==3') 已取消
                span(v-if='scope.row.busStatus==4') 已结束
          el-table-column(prop='busStartTime', header-align='center', align='center', label='开始时间')
          //- el-table-column(prop='type', header-align='center', align='center', label='缴费类型')
          //-     template(slot-scope="scope")
          //-       span(v-if='scope.row.type==1') 预缴费
          //-       span(v-if='scope.row.type==2') 统一结算
          el-table-column(prop="totalAmount", header-align="center", align="center", label="总收入(元)")
            template(slot-scope="scope")
              span() ¥ {{ tableComputed_1(scope.row.totalAmount, scope.row.refundBalance) }} 元
          el-table-column(prop='totalAmount', header-align='center', align='center', label='不含退款收入(元)')
            template(slot-scope="scope")
                font(v-if='scope.row.totalAmount != null')
                  span() ¥ {{parseFloat(scope.row.totalAmount).toFixed(2)}} 元
          el-table-column(prop='totalFranchise', header-align='center', align='center', label='加盟费(元)')
            template(slot-scope="scope")
                font(v-if='scope.row.totalFranchise != null')
                  span() ¥ {{parseFloat(scope.row.totalFranchise).toFixed(2)}} 元
          el-table-column(prop='noFranchise', header-align='center', align='center', label='未结加盟费(元)')
            template(slot-scope="scope")
                font(v-if='scope.row.noFranchise != null')
                  span() ¥ {{parseFloat(scope.row.noFranchise).toFixed(2)}} 元
          el-table-column(prop='refundBalance', header-align='center', align='center', label='退款余额(元)')
            template(slot-scope="scope")
                font(v-if='scope.row.refundBalance != null')
                  span() ¥ {{parseFloat(scope.row.refundBalance).toFixed(2)}} 元
          el-table-column(prop="refundBalance", header-align="center", align="center", label="退款余额度占比(%)")
            template(slot-scope="scope")
              span(:style="tableComputed_3(scope.row.totalAmount, scope.row.refundBalance)") {{ tableComputed_2(scope.row.totalAmount, scope.row.refundBalance) }} %
          //- el-table-column(prop='refundAmt', header-align='center', align='center', label='退款金额(元)')
          //-   template(slot-scope="scope")
          //-       font(v-if='scope.row.refundAmt != null')
          //-         span() ¥ {{parseFloat(scope.row.refundAmt).toFixed(2)}} 元
          el-table-column(prop='serviceFee', header-align='center', align='center', label='提现手续费(元)')
            template(slot-scope="scope")
                font(v-if='scope.row.serviceFee != null')
                  span() ¥ {{parseFloat(scope.row.serviceFee).toFixed(2)}} 元
          //- el-table-column(prop='status', header-align='center', align='center', label='缴费状态')
          //-     template(slot-scope="scope")
          //-       font(v-if='scope.row.status==0')
          //-         span.danger()
          //-         span() &nbsp; 未缴费
          //-       font(v-if='scope.row.type==1 && scope.row.status==1')
          //-         span.success()
          //-         span() &nbsp; 已缴费
          //-       font(v-if='scope.row.type==1 && scope.row.status==2')
          //-         span.warning()
          //-         span() &nbsp; 已退费
          //-       font(v-if='scope.row.type==1 && scope.row.status==3')
          //-         span.warning()
          //-         span() &nbsp; 多余钱款已退
          //-       font(v-if='scope.row.type==2') 线下支付
          el-table-column(prop='orgContactName', header-align='center', align='center', label='联系人')
            template(slot-scope='scope')
              span(:title="scope.row.orgContactName") {{scope.row.orgContactName || ''}}
          el-table-column(prop='orgContactPhone', header-align='center', align='center', label='联系电话')
            template(slot-scope='scope')
              span(:title="scope.row.orgContactPhone") {{scope.row.orgContactPhone || ''}}
          el-table-column(prop='',header-align='center',align='center',label='操作' width='100')
              template(slot-scope="scope")
                el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse")
                  el-submenu(index="1")
                      template(slot="title")
                          i(class="el-icon-more" style='color:#02B90D;')
                      el-menu-item-group()
                          el-menu-item(index="1-1" @click="toDetail(scope.row)") 详情

      el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')

      //报名人员-单打
      elEnrollInfoSingle(v-if='elEnrollInfoSingleVisible',ref="elEnrollInfoSingle",@refreshDataList='getDataList')
      //报名人员--双打
      elEnrollInfoDouble(v-if='elEnrollInfoDoubleVisible',ref="elEnrollInfoDouble",@refreshDataList='getDataList')
      //报名人员--俱乐部
      elEnrollInfoClub(v-if='elEnrollInfoClubVisible',ref="elEnrollInfoClub",@refreshDataList='getDataList')
      //报名人员--培训-单次
      elEnrollInfoTrainSingle(v-if='elEnrollInfoTrainSingleVisible',ref="elEnrollInfoTrainSingle",@refreshDataList='getDataList')
      //报名人员--培训-整期
      elEnrollInfoTrainAll(v-if='elEnrollInfoTrainAllVisible',ref="elEnrollInfoTrainAll",@refreshDataList='getDataList')
      //报名人员--培训-青少年
      elEnrollInfoTrainJuvenile(v-if='elEnrollInfoTrainJuvenileVisible',ref="elEnrollInfoTrainJuvenile",@refreshDataList='getDataList')
      //报名人员--培训-个人
      elEnrollInfoTrainPerson(v-if='elEnrollInfoTrainPersonVisible',ref="elEnrollInfoTrainPerson",@refreshDataList='getDataList')
</template>
<script>
import table from './table.js'
// import table2 from './table2.js'
import ElEnrollInfoSingle from './el-enroll-info-single'
import ElEnrollInfoDouble from './el-enroll-info-double'
import ElEnrollInfoClub from './el-enroll-info-club'
import ElEnrollInfoTrainSingle from './el-enroll-info-train-single'
import ElEnrollInfoTrainAll from './el-enroll-info-train-all'
import ElEnrollInfoTrainJuvenile from './el-enroll-info-train-juvenile'
import ElEnrollInfoTrainPerson from './el-enroll-info-train-person'
export default {
  name: 'statical-franchiseOrgStatical',
  components: {
    ElEnrollInfoSingle,
    ElEnrollInfoDouble,
    ElEnrollInfoClub,
    ElEnrollInfoTrainSingle,
    ElEnrollInfoTrainAll,
    ElEnrollInfoTrainJuvenile,
    ElEnrollInfoTrainPerson
  },
  data () {
    return {
      table: {
        columns: table.columns,
        data: null,
        size: 'mini',
        stripe: true,
        border: true
      },
      elEnrollInfoSingleVisible: false,
      elEnrollInfoDoubleVisible: false,
      elEnrollInfoClubVisible: false,
      elEnrollInfoTrainSingleVisible: false,
      elEnrollInfoTrainAllVisible: false,
      elEnrollInfoTrainJuvenileVisible: false,
      elEnrollInfoTrainPersonVisible: false,
      isCollapse: true,
      timeRange: 1,
      dateTime: [],
      totalAmount: null,
      totalAmountCt: null,
      totalAmountTr: null,
      totalFranchiseCt: null,
      totalFranchiseTr: null,
      totalFranchise: null,
      serviceFee: null,
      dataForm: {
        payTimeStr: '',
        payTimeEnd: '',
        busType: null, //竞赛/培训类型
        busCategory: '',
        busStatus: '',
        orgId: '',
        numType: 1,
        dateType: 1,
        downLoad: false
      },
      busTypeArr: [
        { value: 1, label: '竞赛' },
        { value: 2, label: '培训' }
      ],
      busCategoryArr: [
        { value: -1, label: '青少年赛' },
        { value: 1, label: '分级公开赛' },
        { value: 2, label: '俱乐部公开赛' },
        { value: 3, label: '分级单次培训' },
        { value: 4, label: '分级整期培训' },
        { value: 5, label: '青少年儿童培训' },
        { value: 6, label: '个人定制化培训' },
        { value: 13, label: '分级升级培训' }
      ],
      busStatusArr: [
        { value: 1, label: '未审核' },
        { value: 2, label: '已发布' },
        { value: 3, label: '已取消' },
        { value: 4, label: '已结束' }
      ],
      proviceList: [],
      cityList: [],
      orgList: [],
      dataList: [],
      infoDataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      viewVisible: false

    }
  },
  activated () {
    // 只有当点击"详情"按钮进到本页面时, 也就是 refresh === 1 时, 才需要触发页面刷新
    if (this.$route.query.refresh) {
      this.dataForm.orgId = this.$route.query.orgId
      this.timeRange = this.$route.query.timeRange ? Number(this.$route.query.timeRange) : ''
      const payTimeStr = this.$route.query.payTimeStr
      const payTimeEnd = this.$route.query.payTimeEnd
      if (payTimeStr && payTimeEnd) {
        this.dateTime = [payTimeStr, payTimeEnd]
      }
      this.getDataList()
    }
  },
  computed: {
    // 总收入 = 不含退款收入(a) + 退款余额(b)
    tableComputed_1 () {
      return function (a, b) {
        return (Number(a) + Number(b)).toFixed(2)
      }
    },
    // 退款余额度占比 = 退款余额(b) / 总收入(a + b)
    tableComputed_2 () {
      return function (a, b) {
        if (Number(b) === 0) {
          return '0.00'
        }
        const num1 = Number(b) / (Number(a) + Number(b))
        const num2 = num1 * 100
        const num3 = num2.toFixed(2)
        return num3
      }
    },
    // 退款余额度占比超过 10% 时需要进行标红处理
    tableComputed_3 () {
      return function (a, b) {
        if (Number(b) === 0) {
          return ''
        }
        const num1 = Number(b) / (Number(a) + Number(b))
        const num2 = num1 * 100
        const num3 = num2.toFixed(2)
        if (Number(num3) < 10) {
          return ''
        } else {
          return 'color: red;'
        }
      }
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)//返回上一层
    },
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      if (this.dateTime && this.dateTime.length > 0) {
        this.dataForm.payTimeStr = this.dateTime[0]
        this.dataForm.payTimeEnd = this.dateTime[1]
      }
      this.dataForm.page = this.pageIndex
      this.dataForm.rows = this.pageSize
      this.$http({
        url: this.$http.adornUrl('/frFranchiseFeeRecord/franchiseFeeList2'),
        method: 'post',
        data: this.dataForm
      }).then(data => {
        if (data && data.code === 0) {
          this.dataList = data.page.rows
          this.totalPage = data.page.total
          this.totalAmount = data.totalAmount
          this.totalAmountCt = data.totalAmountCt
          this.totalAmountTr = data.totalAmountTr
          this.totalFranchise = data.totalFranchise
          this.totalFranchiseCt = data.totalFranchiseCt
          this.totalFranchiseTr = data.totalFranchiseTr
          this.serviceFee = data.serviceFee
          if (this.dataList.length > 0) {
            this.infoDataList = [{
              totalAmount: data.totalAmount,
              totalRefundBalanced: data.totalRefundBalanced,
              totalAmountCt: data.totalAmountCt,
              totalAmountTr: data.totalAmountTr,
              totalFranchise: data.totalFranchise,
              totalFranchiseCt: data.totalFranchiseCt,
              totalFranchiseTr: data.totalFranchiseTr,
              serviceFee: data.serviceFee
            }]
          }
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    changeBusType (val) {
      if (val === 1) {
        this.busCategoryArr = [
          { value: -1, label: '青少年赛' },
          { value: 1, label: '分级公开赛' },
          { value: 2, label: '俱乐部公开赛' }
        ]
        if ([-1, 1, 2].indexOf(this.dataForm.busCategory) === -1) {
          this.dataForm.busCategory = null
        }
      } else if (val === 2) {
        this.busCategoryArr = [
          { value: 3, label: '分级单次培训' },
          { value: 4, label: '分级整期培训' },
          { value: 5, label: '青少年儿童培训' },
          { value: 6, label: '个人定制化培训' },
          { value: 13, label: '分级升级培训' }
        ]
        if ([3, 4, 5, 6, 13].indexOf(this.dataForm.busCategory) === -1) {
          this.dataForm.busCategory = null
        }
      } else {
        this.busCategoryArr = [
          { value: -1, label: '青少年赛' },
          { value: 1, label: '分级公开赛' },
          { value: 2, label: '俱乐部公开赛' },
          { value: 3, label: '分级单次培训' },
          { value: 4, label: '分级整期培训' },
          { value: 5, label: '青少年儿童培训' },
          { value: 6, label: '个人定制化培训' },
          { value: 13, label: '分级升级培训' }
        ]
      }
    },
    // 快捷选择时间范围
    timeChange (val) {
      const today = new Date()
      let start = null
      let end = null
      // 0 今天
      // 1 本周(周一到今天)
      // 2 上周(上周一到上周日)
      // 3 本月(本月1号到今天)
      // 4 上月(上月1号到上月最后一天)
      if (val === 0) {
        start = new Date(today.getFullYear(), today.getMonth(), today.getDate())
        end = new Date(today.getFullYear(), today.getMonth(), today.getDate())
      } else if (val === 1) {
        // 周日为 0, 转为 7
        const day = today.getDay() || 7
        // 本周一
        start = new Date(today.getFullYear(), today.getMonth(), today.getDate() - day + 1)
        // 今天
        end = new Date(today.getFullYear(), today.getMonth(), today.getDate())
      } else if (val === 2) {
        const day = today.getDay() || 7
        // 上周日
        end = new Date(today.getFullYear(), today.getMonth(), today.getDate() - day)
        // 上周一
        start = new Date(today.getFullYear(), today.getMonth(), today.getDate() - day - 6)
      } else if (val === 3) {
        // 本月第一天
        start = new Date(today.getFullYear(), today.getMonth(), 1)
        // 今天
        end = new Date(today.getFullYear(), today.getMonth(), today.getDate())
      } else if (val === 4) {
        // 上月
        const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1)
        // 上月第一天
        start = new Date(lastMonth.getFullYear(), lastMonth.getMonth(), 1)
        // 上月最后一天
        end = new Date(lastMonth.getFullYear(), lastMonth.getMonth() + 1, 0)
      }

      this.dateTime = [this.getime(start), this.getime(end)]
    },
    getime (time) {
      let str = ''
      let y = time.getFullYear()
      let m = (time.getMonth() + 1 + '').padStart(2, '0')
      let d = (time.getDate() + '').padStart(2, '0')
      str = `${y}-${m}-${d}`
      return str
    },
    getDownLoadTime (time) {
      let str = ''
      let y = time.getFullYear()
      let m = (time.getMonth() + 1 + '').padStart(2, '0')
      let d = (time.getDate() + '').padStart(2, '0')
      str = `${y}${m}${d}`
      return str
    },
    dayChange () {
      this.timeRange = ''
    },
    dateChange (val) {
      this.dataForm.dateType = val
      this.getDataList()
    },
    handleClose () { },
    handleOpen () { },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    toDetail (row) {
      if (row.busCategory === 1 || row.busCategory == -1) {
        this.$http({
          url: this.$http.adornUrl(`/ctCompetition/getId/` + row.busId),
          method: 'get'
        }).then((data) => {
          if (data && data.code === 0) {
            if (data.bean.projectType === 1) {
              this.elEnrollInfoSingleVisible = true
              this.$nextTick(() => {
                // this.$refs.elEnrollInfoSingle.init(row)
                this.$refs.elEnrollInfoSingle.init(row.busId, row.busType, row.busCategory)
              })
            } else {
              this.elEnrollInfoDoubleVisible = true
              this.$nextTick(() => {
                // this.$refs.elEnrollInfoDouble.init(row.busId)
                this.$refs.elEnrollInfoDouble.init(row.busId, row.busType, row.busCategory)
              })
            }
          }
        })
      } else if (row.busCategory === 2) {
        this.elEnrollInfoClubVisible = true
        this.$nextTick(() => {
          this.$refs.elEnrollInfoClub.init(row.busId, row.busType, row.busCategory)
        })
      } else if (row.busCategory === 3 || row.busCategory === 13) {
        this.elEnrollInfoTrainSingleVisible = true
        this.$nextTick(() => {
          this.$refs.elEnrollInfoTrainSingle.init(row.busId, row.busType, row.busCategory)
        })
      } else if (row.busCategory === 4) {
        this.elEnrollInfoTrainAllVisible = true
        this.$nextTick(() => {
          this.$refs.elEnrollInfoTrainAll.init(row.busId, row.busType, row.busCategory)
        })
      } else if (row.busCategory === 5) {
        this.elEnrollInfoTrainJuvenileVisible = true
        this.$nextTick(() => {
          this.$refs.elEnrollInfoTrainJuvenile.init(row.busId, row.busType, row.busCategory)
        })
      } else if (row.busCategory === 6) {
        this.elEnrollInfoTrainPersonVisible = true
        this.$nextTick(() => {
          this.$refs.elEnrollInfoTrainPerson.init(row.busId, row.busType, row.busCategory)
        })
      }
    },
    //导出列表
    exportExcel () {
      if (this.dateTime && this.dateTime.length > 0) {
        this.dataForm.payTimeStr = this.dateTime[0]
        this.dataForm.payTimeEnd = this.dateTime[1]
      }
      this.dataForm.page = 1
      this.dataForm.rows = 100000
      this.dataForm.downLoad = true
      this.$http({
        url: this.$http.adornUrl('/frFranchiseFeeRecord/franchiseFeeList2'),
        method: 'POST',
        data: this.dataForm
      }).then(data => {
        if (data && data.code === 0) {
          if (data.page.rows == null || data.page.rows.length === 0) {
            this.$message.info('没有要导出的数据!')
            return
          }
          // const totalData = [{
          //   totalAmount: data.totalAmount,
          //   totalRefundBalanced: data.totalRefundBalanced,
          //   totalAmountCt: data.totalAmountCt,
          //   totalAmountTr: data.totalAmountTr,
          //   totalFranchise: data.totalFranchise,
          //   totalFranchiseCt: data.totalFranchiseCt,
          //   totalFranchiseTr: data.totalFranchiseTr,
          //   serviceFee: data.serviceFee
          // }]
          let exportData = data.page.rows
          for (let i of exportData) {
            i.searchDate = i.searchDate + { 1: '', 2: '季度', 3: '年' }[this.dataForm.dateType]
            i.type = { 1: '预缴费', 2: '统一结算' }[i.type]
            i.status = { 0: '未缴费', 1: '已缴费', 2: '已退费', 3: '多余钱款已退' }[i.status]
            i.busStatus = { 1: '未审核', 2: '已发布', 3: '已取消', 4: '已结束' }[i.busStatus]
            i.busType = { 1: '竞赛', 2: '培训' }[i.busType]
            i.busCategory = {
              '-1': '青少年赛',
              1: '分级公开赛',
              2: '俱乐部公开赛',
              3: '分级单次培训',
              4: '分级整期培训',
              5: '青少年儿童培训',
              6: '个人定制化培训',
              13: '分级升级培训'
            }[i.busCategory]
            i.__applySize__ = i.applySize ? `${i.joinCount}/${i.applySize}` : '-' // 签位数(由计算所得)
            i.__totalRevenue__ = this.tableComputed_1(i.totalAmount, i.refundBalance) // 总收入(由计算所得)
            i.__proportion__ = this.tableComputed_2(i.totalAmount, i.refundBalance) // 退款余额度占比(由计算所得)
            // 如果这个数据是可以转化为数字的格式，但我们又不希望它被转化的时候，
            // 就需要在数据前面添加一个“keepString”前缀，这个前缀会在数据被转化为Excel表格的时候被自动删除
            if (i.orgContactPhone) {
              i.orgContactPhone = 'keepString' + i.orgContactPhone
            }
          }
          this.$export.excel({
            columns: this.table.columns,
            data: exportData,
            title: data.page.rows[0].orgName + '加盟费费用表单',
            header: this.dateTime && this.dateTime.length > 0 ? `${this.dateTime[0]} ~ ${this.dateTime[1]}` : ''
          }).then(() => {
            this.$message.success(`${data.page.rows[0].orgName}加盟费费用表单导出成功`)
          })
          // this.$export.excel({
          //   columns: table2.columns,
          //   data: totalData,
          //   title: data.page.rows[0].orgName + '加盟费费用统计'
          // }).then(() => {
          //   this.$message.success(`${data.page.rows[0].orgName}加盟费费用统计导出成功`)
          //   setTimeout(() => {
          //     this.$export.excel({
          //       columns: this.table.columns,
          //       data: exportData,
          //       title: data.page.rows[0].orgName + '加盟费费用表单'
          //     }).then(() => {
          //       this.$message.success(`${data.page.rows[0].orgName}加盟费费用表单导出成功`)
          //     })
          //   }, 1000)
          // })
        }
      })
    }
  }
}
</script>
<style>
/* 操作三点 菜单样式 */
@import '../../css/opr3dot.css';
</style>